<app-page-header
  [className]="'mb-1!'"
  [pageTitle]="'Detalles del prospecto'"
  [showBreadcrumb]="true"
  [showCreateButton]="(!prospecto?.es_cliente && !loading) && permissionAuth.canEdit('prospectos') && permissionAuth.canView('clientes') && permissionAuth.canCreate('clientes')"
  (onCreateClick)="openCreateContacto()"
  [textButton]="'Convertir en cliente'"
  [backRoute]="'/crm/prospectos'"
  [backLabel]="'Prospectos'"
  [currentRoute]="'Detalle'"
  [badgeText]="prospecto?.es_cliente ? 'Ya es cliente' : ''"
/>

@if (!loading && prospecto && selectedIndex !== 0) {
  <div class="relative mt-4 mb-1 p-5 bg-white border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6 dark:bg-white/[0.03]">
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 lg:gap-7">
      <div>
        <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
          Tipo de persona
        </p>
        <p class="text-sm font-medium text-gray-800 dark:text-white/90">
          @if (prospecto.tipo === 'J') {
            <app-badge [startIcon]="'apartment'">Jurídica</app-badge>
          } @else {
            <app-badge [startIcon]="'person'" [color]="'light'">Física</app-badge>
          }
        </p>
      </div>

      <div>
        <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
          @if (prospecto.tipo === 'F') {
            Nombre completo
          } @else {
            Razón social
          }
        </p>
        <p class="text-sm font-medium text-gray-800 dark:text-white/90">
          @if (prospecto.tipo === 'F') {
            {{ prospecto.nombre + ' ' + prospecto.apellido }}
          } @else {
            {{ prospecto.nombre_empresa }}
          }
        </p>
      </div>

      <div>
        <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
          {{ prospecto.documento_tipo_nombre }}
        </p>
        <p class="text-sm font-medium text-gray-800 dark:text-white/90">
          {{ prospecto.documento }}
        </p>
      </div>

      <div>
        <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
          Canal de captación
        </p>
        <p class="text-sm font-medium text-gray-800 dark:text-white/90">
          {{ prospecto.canal_captacion_nombre }}
        </p>
      </div>
    </div>
  </div>
}

<mat-tab-group [(selectedIndex)]="selectedIndex" (selectedIndexChange)="onTabChange($event)" mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="dark:text-white/90">Cabecera</span>
    </ng-template>
    <ng-template matTabContent>
      <div class="mt-6">
        @if (loading) {
          <app-spinner />
        } @else {
          <app-card [title]="'Datos generales'">
            <div card-actions>
              @if (editable) {
                <app-icon-button *hasPermission="'prospectos:edit'"
                  [icon]="'edit'"
                  [ariaLabel]="'Editar'"
                  [title]="'Editar'"
                  [tooltip]="'Editar'"
                  (onClick)="editableSwitcher()"
                />
              }
            </div>
            <app-form [formGroup]="editForm">
              <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
                <div>
                  <app-label for="tipo">Tipo</app-label>
                  <app-select id="tipo" formControlName="tipo" placeholder="Seleccione un tipo" [options]="tipoOptions" />
                </div>

                <div>
                  <app-label for="param_canal_captacion_id">Canal de captación</app-label>
                  <app-select id="param_canal_captacion_id" formControlName="param_canal_captacion_id" placeholder="Seleccione un canal de captación" [options]="canalesCaptacionOptions" />
                </div>

                <div>
                  <app-label for="fecha_solicitud">Fecha de solicitud</app-label>
                  <app-input-field id="fecha_solicitud" type="date" formControlName="fecha_solicitud" />
                </div>

                @if (editForm.get('tipo')?.value === 'F') {
                  <div>
                    <app-label for="nombre">Nombre</app-label>
                    <app-input-field id="nombre" formControlName="nombre" />
                  </div>

                  <div>
                    <app-label for="apellido">Apellido</app-label>
                    <app-input-field id="apellido" formControlName="apellido" />
                  </div>
                } @else {
                  <div>
                    <app-label for="nombre_empresa">Nombre de la empresa</app-label>
                    <app-input-field id="nombre_empresa" formControlName="nombre_empresa" />
                  </div>
                }

                <div>
                  <app-label for="documento">Documento</app-label>
                  <app-input-field id="documento" formControlName="documento" />
                </div>

                <div>
                  <app-label for="per_documento_tipo_id">Tipo de documento</app-label>
                  <app-select id="per_documento_tipo_id" formControlName="per_documento_tipo_id" placeholder="Seleccione un tipo de documento" [options]="documentosTiposOptions" />
                </div>

                <div>
                  <app-label for="telefono">Teléfono</app-label>
                  <app-input-field id="telefono" formControlName="telefono" />
                </div>

                <div>
                  <app-label for="email">Email</app-label>
                  <app-input-field id="email" type="email" placeholder="example@gmail.com" formControlName="email" />
                </div>

                <div>
                  <app-label for="whatsapp">WhatsApp</app-label>
                  <app-input-field id="whatsapp" formControlName="whatsapp" />
                </div>
              </div>

              <div>
                <app-label for="descripcion">Descripción</app-label>
                <app-textarea id="descripcion" formControlName="descripcion" [rows]="4" />
              </div>
            </app-form>
          </app-card>

          <app-edition-buttons *hasPermission="'prospectos:edit'"
            [editable]="editable"
            [process]="updating"
            [valid]="editForm.valid"
            [hideEditButton]="true"
            (onGoBackClick)="goBack()"
            (onEditClick)="editableSwitcher()"
            (onCancelClick)="refreshProspecto()"
            (onUpdateClick)="updateProspecto()"
          />
        }
      </div>
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="dark:text-white/90">Contactos</span>
    </ng-template>
    <ng-template matTabContent>
      <app-contactos [idProspecto]="idProspecto" (onGenerarPropuesta)="goToPropuestas($event)" />
    </ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="dark:text-white/90">Propuestas comerciales</span>
    </ng-template>
    <ng-template matTabContent>
      <app-propuestas-comerciales [idProspecto]="idProspecto" [idContacto]="idContacto" />
    </ng-template>
  </mat-tab>
</mat-tab-group>
